import type { RouteObject } from "react-router";

import MaintenancePage from "@/modules/maintenance-page";
import SSOErrorPage from "@/modules/sso-error-page";

export const STATIC_ROUTES: RouteObject[] = [
  {
    path: "/maintenance",
    element: <MaintenancePage />,
  },
  {
    path: "/sso/error",
    element: <SSOErrorPage />,
  },
];
